import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';


const Methodology = ({ content }) => (
  <div className="post fade-in">
    <h1 className="text-center">Módszertan</h1>
    <div className="post__content">
      {ReactHtmlParser(content)}
    </div>
  </div>
);


Methodology.propTypes = {
  content: PropTypes.string.isRequired
};


export default Methodology;



// WEBPACK FOOTER //
// ./src/components/Methodology/Methodology.js